// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultLayout_root__11Qj-","routeContainer":"DefaultLayout_routeContainer__3qizC","content":"DefaultLayout_content__KXu3E"};